import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 402  -  移动图片
 */
import EventFilter from './EventFilter'

export default class EventMovePic extends EventBase {
  /**
   * 移动图片构造函数
   */
  constructor(parameter?: string[]) {
    super()
    this.Parameter = parameter || [
      '1',
      '',
      '0',
      '0',
      '0',
      '100',
      '100',
      '255',
      '0',
      '30',
      '',
      '0',
      '0',
      '',
      '',
      '',
      '',
    ]
  }
  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 图片相对路径
   */
  get PicPath() {
    return this.Parameter?.[1] || ''
  }
  set PicPath(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /// <summary>
  /// 图片坐标是否为橙光数值指定
  /// 0为非数值指定（常量），1为是橙光动态数值指定
  /// </summary>
  get IsAssigned() {
    return this.Parameter?.[2] == '1'
  }
  set IsAssigned(value) {
    this.Parameter && (this.Parameter[2] = value ? '1' : '0')
  }
  /**
   * X坐标
   */
  get X() {
    return parseInt(this.Parameter?.[3] || '')
  }
  set X(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * Y坐标
   */
  get Y() {
    return parseInt(this.Parameter?.[4] || '')
  }
  set Y(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * X轴缩放率
   */
  get ZoomX() {
    return Number(this.Parameter?.[5] ?? '0')
  }
  set ZoomX(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  /**
   * Y轴缩放率
   */
  get ZoomY() {
    return Number(this.Parameter?.[6] ?? '0')
  }
  set ZoomY(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }
  /**
   * 图片透明度，0~255
   */
  get Opacity() {
    return parseInt(this.Parameter?.[7] ?? '')
  }
  set Opacity(value) {
    this.Parameter && (this.Parameter[7] = value.toString())
  }
  /// <summary>
  /// 是否使用了镜像功能
  /// 0否1是
  /// </summary>
  get IsMirror() {
    return this.Parameter?.[8] === '1'
  }
  set IsMirror(value) {
    this.Parameter && (this.Parameter[8] = value ? '1' : '0')
  }

  /**
   * 移动时间，固定存储为帧数。
   */
  get Time() {
    return Number(this.Parameter?.[9] ?? '0')
  }
  set Time(value) {
    this.Parameter && (this.Parameter[9] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[10] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[10] = value.toString())
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.MovePic

  /**
   * 编辑器显示单位：0=帧，1=秒；运行时仍读取 Time 帧数。
   */
  get Type() {
    return parseInt(this.Parameter?.[11] ?? '')
  }

  set Type(value) {
    this.Parameter && (this.Parameter[11] = value.toString())
  }

  get Filter() {
    return new EventFilter(this.Parameter ?? [], 13)
  }

  set Filter(value) {
    this.Parameter = value.ToParameter(this.Parameter ?? [], 13)
    this.Parameter[12] = this.Parameter[12] || '0'
  }

  /**
   * 获得该事件在事件列表的描述信息（对于显示图片而言，是第9项）
   */
  /// <returns>事件描述信息</returns>
}
